// extracted by mini-css-extract-plugin
module.exports = {"Row":"Row_Row__3TMZo","Col":"Row_Col__3Oijx"};